import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "list",
    "availabilityId",
    "show",
    "checkmark",
    "li",
    "dropdown",
  ];

  static values = {
    disabled: Boolean,
  };

  connect() {
    this.setDisabled(this.disabledValue);
  }

  toggle(event) {
    event.preventDefault();

    if (this.disabledValue) {
      return;
    }

    if (this.listTarget.getAttribute("aria-expanded") === "false") {
      this.show();
    } else {
      this.hide();
    }
  }

  setDisabled(disabled) {
    this.disabledValue = disabled;

    if (this.disabledValue) {
      this.showTarget.classList.add("bg-gray-100", "cursor-not-allowed");
      this.showTarget.classList.remove("cursor-default");
      this.showTarget.removeAttribute("data-action");
    } else {
      this.showTarget.classList.remove("bg-gray-100", "cursor-not-allowed");
      this.showTarget.classList.add("cursor-default");
      this.showTarget.setAttribute(
        "data-action",
        "click->custom-select#toggle"
      );
    }
  }

  handleClick(event) {
    if (event.target.closest("div") === this.dropdownTarget) {
      this.toggle(event);
    } else if (event.target !== this.showTarget) {
      this.hide();
    }
  }

  show() {
    this.listTarget.classList.remove("hidden");
    this.listTarget.setAttribute("aria-expanded", "true");
  }

  hide() {
    this.listTarget.classList.add("hidden");
    this.listTarget.setAttribute("aria-expanded", "false");
  }

  saveOption(event) {
    this.selectedLi = event.target.closest("li");
    this.id = this.selectedLi.dataset.id;
    this.availabilityIdTarget.value = this.id;
    this.showTarget.value = this.selectedLi.dataset.name;
    this.liTargets.forEach((item) => item.classList.remove("font-semibold"));
    this.selectedLi.classList.add("font-semibold");

    [this.showCheckmark] = this.checkmarkTargets.filter(
      (item) => item.dataset.id === this.id
    );
    this.showCheckmark.classList.remove("hidden");

    this.hideCheckmarks = this.checkmarkTargets.filter(
      (item) => item.dataset.id !== this.id
    );
    this.hideCheckmarks.forEach((item) => item.classList.add("hidden"));

    this.listTarget.classList.add("hidden");
  }
}
